import { Component, Input } from '@angular/core';
import {IonicModule, PopoverController, RangeCustomEvent} from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import {DatePipe, NgIf} from '@angular/common';

@Component({
  selector: 'app-switch-project-alert',
  templateUrl: './switch-project-alert.component.html',
  styleUrls: ['./switch-project-alert.component.scss'],
  standalone: true,
  imports: [DatePipe, FormsModule, IonicModule, NgIf],
})
export class SwitchProjectAlertComponent {
  @Input() name: string;
  @Input() min: number;
  @Input() max: number;
  @Input() value: number;

  constructor(private readonly popoverController: PopoverController) {}

  onIonInput(event: RangeCustomEvent): void {
    this.value = event.detail.value as number;
  }

  bumpValue(dir: string): void {
    switch (dir) {
      case '-':
        this.value -= 60000;
        break;
      case '+':
        this.value += 60000;
        break;
    }
  }

  closePopover(act: string): void {
    this.popoverController.dismiss({
      save: act === 'save',
      value: this.value,
    }).then();
  }
}
